import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import _ from 'lodash';
import * as actions from '../../actions/index';
import {
  SearchBar,
  Title,
  TableFooter,
  Paper,
  Modal,
  ClientModal,
  EmptyView,
  Table,
  Button
} from '../../components';
import {
  handleSearchChange,
  handleExporteToCsv,
  handleSearchBlur,
  handleRowClick,
  handleCloseModal,
  initUsers
} from './Clients.services';
import { styles } from './Clients.styles';
import { ReactComponent as ImportedSVG } from '../../assets/pictures/people.svg';
import { EMPTY_DESIGN_CLIENTS_TITLE } from '../../constants/dishopInfo';
import { CLIENT_TABLE_HEAD } from '../../constants/table';
import apiService from '@dishopsaas/dishop-backend-api-service'

class Clients extends Component {
  state = {
    searchTerm: '',
    currentClients: [],
    isLoading: true,
    accesArray: [],
    client: {},
    allUsers: {}
  };

  async componentDidMount() {
    const allUsers = await apiService.usersGetAll() // TODO this HEAVY Api call exists in PushNotification AND Clients AND Support.View PERF-- PAGINATE BACKEND
    await this.setState({ allUsers });
    await initUsers(this.props, this);
  }

  async componentWillReceiveProps(props) {
    const { allUsers } = this.state;
    const { shopId, isAllShops } = props;
    const { shopId: oldShopId, isAllShops: oldIsAllShops } = this.props;
    if (
      (!_.isEmpty(allUsers) && !_.isEqual(shopId, oldShopId)) ||
      (_.isEqual(shopId, oldShopId) && oldIsAllShops !== isAllShops)
    ) {
      await initUsers(props, this);
    }
  }

  createTableRow = data => {
    const { classes } = this.props;
    return (
      <TableBody>
        {_.map(data, e => {
          const { email, nbTransaction, nbTransactionCanceled, totalMoneySpent, id, number } = e;
          return (
            <TableRow
              key={id}
              onClick={() => handleRowClick(e, this)}
              style={{ cursor: 'pointer' }}
            >
              <TableCell align="center" className={classes.valueC}>
                {email}
              </TableCell>
              <TableCell align="center" className={classes.valueC}>
                {number}
              </TableCell>
              <TableCell align="center" className={classes.valueC}>
                {nbTransaction || 0}
              </TableCell>
              <TableCell align="center" className={classes.valueC}>
                {nbTransactionCanceled || 0}{' '}
              </TableCell>
              <TableCell align="center" className={classes.valueC}>
                {' '}
                {totalMoneySpent || 0} €{' '}
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    );
  };

  render() {
    const { classes, showHelpModal, isAllShops } = this.props;
    const { client, modalOpen, currentClients, clients, allClients } = this.state;
    return (
      <div className="px-4 pb-4">
        <Title title="Clients" onClick={() => showHelpModal('clients')} />
        <div className="pb-3">
          <div className="row">
            {(_.size(clients) > 0 || (isAllShops && _.size(allClients) > 0)) && (
              <>
                <div className="col mt-3 mt-sm-0 d-flex  align-self-center">
                  <SearchBar
                    value={this.state.searchTerm}
                    onChange={e => handleSearchChange(e, this)}
                    onBlur={() => handleSearchBlur(this)}
                    onClick={() => handleSearchBlur(this)}
                  />
                </div>
                <div className="col mt-3 mt-sm-0 d-flex flex-row-reverse align-self-center">
                  <Button
                    className="btn-xs-block"
                    onClick={() => {
                      handleExporteToCsv(this);
                    }}
                    outlined
                    color="secondary"
                  >
                    Exporter la liste des clients
                  </Button>
                </div>
              </>
            )}
          </div>
        </div>
        {!(_.size(currentClients) > 0) ? (
          <EmptyView
            src={ImportedSVG}
            title={EMPTY_DESIGN_CLIENTS_TITLE}
            text={EMPTY_DESIGN_CLIENTS_TITLE}
            isLoading={this.state.isLoading}
          />
        ) : (
          <>
            <Paper scrollOption="auto">
              <Table
                headCells={CLIENT_TABLE_HEAD}
                classes={classes}
                bodyRows={currentClients}
                createTableRow={(currentClients) => this.createTableRow(currentClients)}
                order="desc"
                orderBy="totalMoneySpent"
              />
            </Paper>
            <TableFooter lengthOption={currentClients.length} />
          </>
        )}

        <Modal
          color="secondary"
          title={`Détails du Client `}
          header
          fixed
          width="700px"
          onClick={() => handleCloseModal(this)}
          btnTxt="Retour"
          btnColor="secondary"
          handleClose={() => handleCloseModal(this)}
          isOpen={modalOpen}
        >
          <ClientModal client={client} />
        </Modal>
      </div>
    );
  }
}
function mapStateToProps({ user, page, firebaseRealTime }) {
  const { shopId, shopName, clients, isAllShops } = user;
  const { shops } = firebaseRealTime;

  return {
    page,
    clients,
    shopId,
    shopName,
    isAllShops,
    shops
  };
}

Clients.propTypes = {
  classes: PropTypes.element.isRequired
};

export default connect(mapStateToProps, actions)(withStyles(styles)(Clients));
